export const Panel = {
  Case: 'case',
  Questioneer: 'questioneer',
  InvoiceAddress: 'invoiceAdress',
  EntrepreneurAndSupervisor: 'entrepreneur&supervisor',
  Purpose: 'purpose',
  WorkPerformedIn: 'workPerformed',
  WorkMethod: 'workMethod',
  AdditionalInformation: 'additionalInformation',
  DateAndTimePeriod: 'dateAndTimePeriod',
  Location: 'location',
  Extent: 'extent',
  ConnectedCases: 'connectedCases',
  Recovery: 'recovery',
  TermsAndConditions: 'termsAndCoditions',
  CreateTAPlan: 'createTAPlan',
  WorkType: 'workType',
  MarkingManager: 'markingManager',
  InspectionManager: 'inspectionManager',
  CreateLeasehold: 'createLeasehold',
  LeaseholdTypes: 'leaseholdTypes'
};
